import { CompositeFilterDescriptor } from "@progress/kendo-data-query";
import { normalizeDateFilters } from "../utils/kendo";
import { BaseService } from "./base.service";

class AuditLogService extends BaseService {
  constructor() {
    super("AuditLog");
  }

  async getProjectAuditHistoryPaged(
    projectId: string,
    filter?: CompositeFilterDescriptor | null,
    sort?: any,
    pageNumber = 0,
    pageSize = 20
  ) {
    const normalizedFilter = filter ? normalizeDateFilters(filter) : null;

    // Backend ParseFilter expects: filter.Filters = array of groups,
    // each group.Filters = array of leaf field descriptors.
    // projectId must be wrapped in its own group — not a flat descriptor at root level.
    const mergedFilter: CompositeFilterDescriptor = {
      logic: "and",
      filters: [
        {
          logic: "and",
          filters: [{ field: "projectId", operator: "eq", value: projectId }],
        } as CompositeFilterDescriptor,
        ...(normalizedFilter?.filters ?? []),
      ],
    };

    return this.get([], mergedFilter, sort, pageNumber, pageSize);
  }
}

const auditLogSvc = new AuditLogService();

export default auditLogSvc;
